import { render, staticRenderFns } from "./Cotizaciones.vue?vue&type=template&id=b150a9e6&"
import script from "./Cotizaciones.vue?vue&type=script&lang=js&"
export * from "./Cotizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports